module.exports = "/fonts/PatrickHand-Regular.ttf";